var exports = {
  "kL": "x234b8571--c92c28--container",
  "wm": "x234b8571--c92c28--logo",
  "DD": "x234b8571--c92c28--title",
};

module.exports = exports;
